import { render, staticRenderFns } from "./CourseInformation.vue?vue&type=template&id=e4c1d556&scoped=true&"
import script from "./CourseInformation.vue?vue&type=script&lang=js&"
export * from "./CourseInformation.vue?vue&type=script&lang=js&"
import style0 from "./CourseInformation.vue?vue&type=style&index=0&id=e4c1d556&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4c1d556",
  null
  
)

export default component.exports